import React from 'react';
import '../App.css';
import './HeroSection.css';

function HeroSectionProyects1() {
  return (
    <div className='hero-container'>
      <video src='/videos/positos1.mp4' autoPlay loop muted />
      <h1>LOS POCITOS</h1>
      <div className='hero-btns'>
      </div>
    </div>
  );
}

export default HeroSectionProyects1;
